import { useTranslation } from 'react-i18next'
import { cn, formatDistanceToNow } from '@/lib/utils'
import type { AppNotification } from '@/lib/sdk-official/resources/notifications'
import { SETTINGS_ALERTS } from './settingsAlerts'

export const SettingsAlertNotice = ({ n, onOpen }: { n: AppNotification; onOpen: (path: string) => void }) => {
  const { t } = useTranslation('notifications')
  const alert = SETTINGS_ALERTS[n.type]
  if (!alert) return null
  const Icon = alert.icon
  return (
    <div data-notification={n.type} role="button" onClick={() => onOpen(alert.path)}
      className={cn('flex gap-3 border-b border-border px-3 py-3', !n.read && 'bg-primary-50/50')}>
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-warning-surface text-warning-text">
        <Icon className="h-5 w-5" />
      </span>
      <div className="min-w-0 flex-1">
        <p className="text-sm text-foreground">{alert.text(n, t)}</p>
        <p className="mt-0.5 text-xs text-muted-foreground">{formatDistanceToNow(new Date(n.createdAt))}</p>
        <p className="mt-1 text-xs font-medium text-primary">{t(alert.action)}</p>
      </div>
      {!n.read && <span className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-danger" aria-hidden />}
    </div>
  )
}
